__webpack_require__.p = "https://chat.v2-stg.thuocsi.vn/_next/";